import { useSearchParams } from 'react-router-dom';
import { Drawer } from '../../Atoms/Drawer';
import { DetailsDisplay } from './DetailsDisplay';
import { useLocation } from 'react-router-dom';
import { InventoryAsset, SupportCasesItem, PortalUserData } from '../../../types';
import { Team } from '../../../store/Team';
import { AccountData } from '../../../store/Accounts';
import { ComponentName, getTitle, subTitle } from './detailsDrawersHelpers';
import { PriceBenchMark } from '../../../store/PriceBenchMark';
import { WorkflowOrder } from '../../../Api/Orders/ordersApi';

export type DetailsDrawerProps = {
  title?: string;
  subtitleKey?: string;
  titleKey?: string;
  componentName?: ComponentName;
  data?: InventoryAsset | SupportCasesItem | PortalUserData | Team | AccountData | PriceBenchMark | WorkflowOrder;
  showDrawer: boolean;
  link?: string;
  saveAction?: () => Promise<void>;
  saveDisabled?: boolean;
  showButtons?: boolean;
  approvalEnabled?: boolean;
  onApprovalComplete?: () => void;
  onRefresh?: () => void;
};

export function DetailsDrawer({
  title,
  subtitleKey,
  titleKey,
  componentName,
  data,
  showDrawer,
  link = '',
  saveAction,
  saveDisabled,
  showButtons,
  approvalEnabled,
  onApprovalComplete,
  onRefresh
}: DetailsDrawerProps) {
  const [params, setParams] = useSearchParams();

  const handleDetailClick = () => {
    if (params.has('detailId')) params.delete('detailId');
    setParams(params, { replace: true });
  };

  const location = useLocation();
  const state = {
    data,
    prevpath: location.pathname,
    title,
    componentName
  };

  if (!componentName || !data) return <div></div>;

  return (
    <Drawer
      data-testid="details-drawer"
      show={showDrawer}
      title={getTitle(title, data, titleKey)}
      subtitle={subTitle(componentName, data, subtitleKey || '')}
      setShow={handleDetailClick}
      saveAction={saveAction}
      saveDisabled={saveDisabled}
      showButtons={showButtons}
      link={link}
      componentName={componentName}
      state={state}
      data={data}
      onRefresh={onRefresh}>
      <DetailsDisplay
        data={data}
        componentName={componentName}
        setShow={handleDetailClick}
        approvalEnabled={approvalEnabled}
        onApprovalComplete={onApprovalComplete}
      />
    </Drawer>
  );
}
